import { render } from "./DesignTauri.vue?vue&type=template&id=98e86a8a&scoped=true"
import script from "./DesignTauri.vue?vue&type=script&lang=js"
export * from "./DesignTauri.vue?vue&type=script&lang=js"

import "./DesignTauri.vue?vue&type=style&index=0&id=98e86a8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e86a8a"]])

export default __exports__